// src/components/PhoneInputPopup.js
import React, { useState } from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 400px;
  width: 90%;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const Title = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.8em;
`;

const Message = styled.p`
  color: #555;
  margin-bottom: 25px;
  font-size: 1.1em;
`;

const InputField = styled.input`
  width: calc(100% - 20px);
  padding: 12px 10px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1.1em;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

const SubmitButton = styled.button`
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.1em;
  font-weight: bold;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #218838;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #999;
  font-size: 1.2em;
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  &:hover {
    color: #333;
  }
`;

const PhoneInputPopup = ({ isOpen, onClose, onSubmitPhone }) => {
  const [phoneNumber, setPhoneNumber] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phoneNumber.trim()) {
      onSubmitPhone(phoneNumber);
      setPhoneNumber(''); // রিসেট
    } else {
      alert('অনুগ্রহ করে আপনার ফোন নম্বর দিন।');
    }
  };

  return (
    <Overlay>
      <PopupContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>আপনার ফোন নম্বর দিন</Title>
        <Message>আপনার অর্ডার এবং জরুরি তথ্যের জন্য আপনার ফোন নম্বরটি প্রয়োজন।</Message>
        <form onSubmit={handleSubmit}>
          <InputField
            type="tel"
            placeholder="আপনার ফোন নম্বর (যেমন: 01xxxxxxxxx)"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            pattern="[0-9]{11}" // 11 ডিজিটের ফোন নম্বর
            title="১১ ডিজিটের একটি বৈধ ফোন নম্বর দিন"
          />
          <SubmitButton type="submit">জমা দিন</SubmitButton>
        </form>
      </PopupContent>
    </Overlay>
  );
};

export default PhoneInputPopup;